<template>
  <v-dialog v-model="show" persistent max-width="300">
    <v-card :loading="busy">
      <v-card-title>Update status</v-card-title>
      <v-divider/>
        <v-form>
          <v-container class="mt-2">
            <v-row>
              <v-col cols="8">
                <v-select label="Status" outlined dense v-model="status" :items="['Pending','Accepted','Closed','Rejected']"/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer></v-spacer>
        <v-btn plain color="primary" @click="show=false;$emit('done',false)">Cancel</v-btn>
        <v-btn color="primary" @click="update()" :loading="busy">Update</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SalesEstimatesUpdateStatus',
  props: {
    estimate: {type:Object, required:false},
  },
  data() {
    return {
      show: true,
      busy: false,
      status: this.estimate.status
    }
  },
  methods: {
    async update() {
      this.busy = true;
      const results = await this.$apiCall(`mutation SalesEstimatesUpdateStatus($id: ID!, $status: EstimateStatus!) {
                                            estimateSetStatus(id:$id, status:$status) {status}
                                            }`,
                                          {id:this.estimate.id, status:this.status});
      this.busy = false;
      if (!results.error) {
        this.estimate.status = results.data.estimateSetStatus.status;
        this.show = false;
        this.$emit('done',true);
        this.$store.commit('setError', {type:'success',message:`Updated status for estimate to ${this.estimate.customer.name}`});
      }
    }
  }
}
</script>